module.exports = __webpack_public_path__ + "static/media/shi_dark.54db22d0.png";